import { Directive, inject, Input } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { NetzbetreiberService } from '../../service/netzbetreiber/netzbetreiber.service';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Directive(
    {
        selector: '[redispatchAvailableStadtwerkeId]',
        providers: [
            {
                provide: NG_ASYNC_VALIDATORS,
                useExisting: AvailableStadtwerkeIdDirective,
                multi: true,
            },
        ],
        standalone: false,
    },
)
export class AvailableStadtwerkeIdDirective implements Validator {

    // if set to false, do not perform validation
    @Input() redispatchAvailableStadtwerkeId = true;

    private netzbetreiberService = inject(NetzbetreiberService);

    validate(stadtwerkeId: AbstractControl): Observable<ValidationErrors | null> | ValidationErrors {
        {
            if (!stadtwerkeId.value || !this.redispatchAvailableStadtwerkeId) {
                return of(null);
            }
            return this.netzbetreiberService.isStadtwerkeIdAvailable(stadtwerkeId.value)
                .pipe(
                    map(available => {
                        return (!available)
                            ? { 'availableStadtwerkeId': true }
                            : null;
                    }),
                );
        }
    }

}
